// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginsignup{
    width: 100%;
    height: 80vh;
    background: #fce3fe;
    padding-top: 100px;

}
.loginsignup-container{
    width: 580px;
    height: 600px;
    background: white;
    margin: auto;
    padding: 40px 60px;

}
.loginsignup-container h1{
    margin: 20px 0px;

}
.loginsignup-fields{
    display: flex;
    flex-direction: column;
    gap: 29px;
    margin-top: 30px;
}
.loginsignup-fields input{
    height: 65px;
    width: 100%;
    padding-left: 20px;
    border: 1px solid #c9c9c9;
    outline: none;
    color: #5c5c5c;
    font-size: 18px;
}
.loginsignup-container button{
    width: 580px;
    height: 72px;
    color: white;
    background: #ff4141;
    margin-top: 30px;
    border: none;
    font-size: 24px;
    font-weight: 500;
    cursor: pointer;
}
.loginsignup-login{
    margin-top: 20px;
    color: #5c5c5c;
    font-size: 18px;
    font-weight: 500;
}
.loginsignup-login span{
    color: #ff4141;
    font-weight: 600;
}
.loginsignup-agree{
    display: flex;
    align-items: center;
    margin-top: 25px;
    gap: 20px;
    color: #5c5c5c;
    font-size: 18px;
    font-weight: 500;
}
@media(max-width:1280px){
    .loginsignup{
        padding-top: 50px;
    }
    .loginsignup-container{
        width: auto;
        max-width: 500px;
        max-height: 500px;
    }
    .loginsignup-container h1{
        margin: 10px 0px;

    }
    .loginsignup-fields{
        gap: 20px;
        margin-top: 20px;
    }
    .loginsignup-fields input{
        height: 65px;
        width: 93%;
    }
    .loginsignup-container button{
        width: 100%;
    }
    .loginsignup-login{
        font-size: 16px;
    }
    .loginsignup-agree{
        font-size: 14px;
        gap: 10px;
    }
}
@media(max-width:800px){
    
    .loginsignup-container{
        padding: 20px 30px;
    }
    .loginsignup-container h1{
        font-size: 24px;

    }
    .loginsignup-fields{
        
        margin-top: 20px;
    }
    .loginsignup-fields input{
        height: 50px;
       
    }
    .loginsignup-container button{
        height: 50px;
        font-size: 16px;
    }
    
}
`, "",{"version":3,"sources":["webpack://./src/Pages/CSS/LoginSignup.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;;AAEtB;AACA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;;AAEtB;AACA;IACI,gBAAgB;;AAEpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,eAAe;AACnB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,gBAAgB;;IAEpB;IACA;QACI,SAAS;QACT,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,UAAU;IACd;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,SAAS;IACb;AACJ;AACA;;IAEI;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;;IAEnB;IACA;;QAEI,gBAAgB;IACpB;IACA;QACI,YAAY;;IAEhB;IACA;QACI,YAAY;QACZ,eAAe;IACnB;;AAEJ","sourcesContent":[".loginsignup{\n    width: 100%;\n    height: 80vh;\n    background: #fce3fe;\n    padding-top: 100px;\n\n}\n.loginsignup-container{\n    width: 580px;\n    height: 600px;\n    background: white;\n    margin: auto;\n    padding: 40px 60px;\n\n}\n.loginsignup-container h1{\n    margin: 20px 0px;\n\n}\n.loginsignup-fields{\n    display: flex;\n    flex-direction: column;\n    gap: 29px;\n    margin-top: 30px;\n}\n.loginsignup-fields input{\n    height: 65px;\n    width: 100%;\n    padding-left: 20px;\n    border: 1px solid #c9c9c9;\n    outline: none;\n    color: #5c5c5c;\n    font-size: 18px;\n}\n.loginsignup-container button{\n    width: 580px;\n    height: 72px;\n    color: white;\n    background: #ff4141;\n    margin-top: 30px;\n    border: none;\n    font-size: 24px;\n    font-weight: 500;\n    cursor: pointer;\n}\n.loginsignup-login{\n    margin-top: 20px;\n    color: #5c5c5c;\n    font-size: 18px;\n    font-weight: 500;\n}\n.loginsignup-login span{\n    color: #ff4141;\n    font-weight: 600;\n}\n.loginsignup-agree{\n    display: flex;\n    align-items: center;\n    margin-top: 25px;\n    gap: 20px;\n    color: #5c5c5c;\n    font-size: 18px;\n    font-weight: 500;\n}\n@media(max-width:1280px){\n    .loginsignup{\n        padding-top: 50px;\n    }\n    .loginsignup-container{\n        width: auto;\n        max-width: 500px;\n        max-height: 500px;\n    }\n    .loginsignup-container h1{\n        margin: 10px 0px;\n\n    }\n    .loginsignup-fields{\n        gap: 20px;\n        margin-top: 20px;\n    }\n    .loginsignup-fields input{\n        height: 65px;\n        width: 93%;\n    }\n    .loginsignup-container button{\n        width: 100%;\n    }\n    .loginsignup-login{\n        font-size: 16px;\n    }\n    .loginsignup-agree{\n        font-size: 14px;\n        gap: 10px;\n    }\n}\n@media(max-width:800px){\n    \n    .loginsignup-container{\n        padding: 20px 30px;\n    }\n    .loginsignup-container h1{\n        font-size: 24px;\n\n    }\n    .loginsignup-fields{\n        \n        margin-top: 20px;\n    }\n    .loginsignup-fields input{\n        height: 50px;\n       \n    }\n    .loginsignup-container button{\n        height: 50px;\n        font-size: 16px;\n    }\n    \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
